/**
 * @file index.js
 * @description Entry point utama aplikasi React.
 * Merender App ke dalam DOM dengan BrowserRouter sebagai provider routing.
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './reducers/store';
import App from './app/App';

// -------------------------------------------------------------------
// Suppress known legacy warnings dari library pihak ketiga (reactstrap)
// -------------------------------------------------------------------
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    (
      args[0].includes('Support for defaultProps will be removed from function components') ||
      args[0].includes('uses the legacy childContextTypes API') ||
      args[0].includes('uses the legacy contextTypes API') ||
      args[0].includes('findDOMNode is deprecated')
    )
  ) {
    return;
  }
  originalError(...args);
};

// -------------------------------------------------------------------
// Mount aplikasi
// -------------------------------------------------------------------
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
